module.exports = __webpack_public_path__ + "static/custompropdef-a13090555c97a5eaee471c876eec4ecd.png";